import React, { useEffect, useRef, useState } from 'react';
import { Tooltip } from '@mui/material';
import './TooltipWithTypography.scss';
import TableCellTypography from '../tabel-cell-typography';  // SCSS 파일 가져오기

interface TooltipWithTypographyProps {
  value: string | number | null;
}

const TooltipWithTableCellTypography: React.FC<TooltipWithTypographyProps> = ({
  value,
}) => {

  const [isEllipsisActive, setIsEllipsisActive] = useState(false);
  const textRef = useRef<HTMLSpanElement>(null);

  useEffect(() => {
    const checkEllipsis = () => {
      if (textRef.current) {
        const { scrollWidth, offsetWidth } = textRef.current;
        // 텍스트가 잘렸는지 확인
        setIsEllipsisActive(scrollWidth > offsetWidth);
      }
    };

    // 컴포넌트가 마운트될 때 및 값이 변경될 때마다 체크
    checkEllipsis();

    // 윈도우 리사이즈 시에도 텍스트가 잘리는지 확인
    window.addEventListener('resize', checkEllipsis);
    return () => window.removeEventListener('resize', checkEllipsis);
  }, [value]);

  return (
    <TableCellTypography>
      <span ref={textRef} className="ellipsis-text">
        {isEllipsisActive ? (
          <Tooltip
            title={value ?? '--'}
            classes={{ tooltip: 'custom-tooltip' }}
            PopperProps={{
              modifiers: [
                {
                  name: 'flip',
                  enabled: false,
                },
                {
                  name: 'preventOverflow',
                  options: {
                    altBoundary: true,
                    rootBoundary: 'document',
                    tether: false,
                  },
                },
              ],
            }}
          >
            <span>{value ?? '--'}</span>
          </Tooltip>
        ) : (
          <span>{value ?? '--'}</span>
        )}
      </span>
    </TableCellTypography>
  );
};

export default TooltipWithTableCellTypography;
